<div class="ui-g ui-fluid">
    <div class="ui-g-12">
        <!-- Left Side -->
        <div class="card card-w-title">

            <div class="ui-g form-group">
                <div class=" ui-md-2">
                    <label><b>Country</b></label>
                    <p-dropdown id="dropdown" [disabled]="this.posting" [options]="countries"
                        [(ngModel)]="query.country_id" (onChange)="GetPatients(null)" [filter]="true"
                        [filterBy]='"label"'>
                    </p-dropdown>
                </div>

                <div class=" ui-md-2" style="padding-top: 30px;">
                    <p-checkbox [(ngModel)]="disabledDates" [disabled]="this.posting"
                        (onChange)="query.from_date=null; query.to_date=null; GetPatients(null);"
                        [binary]="true"></p-checkbox>
                    <label style="padding-left:3px;font-style:bold">Disable Dates?</label>
                </div>
                <div class="ui-md-8">

                </div>
                <div class="ui-md-2">

                    <label><b>From:</b></label>
                    <p-calendar [showIcon]="true" class="notranslate" [disabled]="disabledDates || posting" [maxDate]="this.maxDate"
                        placeholder="dd/mm/yyyy" dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
                        yearRange="1900:2099" [(ngModel)]="query.from_date"
                        (ngModelChange)="GetPatients(null)"></p-calendar>
                </div>
                <div class="ui-md-2">
                    <label><b>To:</b></label>
                    <p-calendar [showIcon]="true" [disabled]="disabledDates || posting" class="notranslate" [minDate]="query.from_date"
                        [maxDate]="this.maxDate" [defaultDate]="query.from_date" placeholder="dd/mm/yyyy"
                        dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2099"
                        [(ngModel)]="query.to_date" (ngModelChange)="GetPatients(null)"></p-calendar>
                </div>
                <div class="ui-md-4" style="padding-top: 30px;">
                    <p-progressSpinner [style]="{'width': '25px', 'height': '25px', 'vertical-align' : 'middle'}"
                        *ngIf="this.posting" strokeWidth="6">
                    </p-progressSpinner>
                    <button pButton type="submit" label="Reset" [disabled]="this.posting"
                        style="margin-bottom:10px;margin-right:5px;width:190px;" (click)="InitFilter(true)"></button>
                </div>
                <div class="ui-md-12" style="color: red;" *ngIf="response.success!=null && !response.success">
                    <p>{{response.error.message}}</p>
                </div>
                <div class="ui-md-12" style="color: red;" *ngIf="invalid_date_message">
                    <p>Please select the From date and To date</p>
                </div>
            </div>
        </div>

    </div>
</div>

<div class="mat-elevation-z8" style="margin-top:3%">
    <div class="table-responsive text-center justify-content-center"
        style="font-size:14px; margin-bottom: 20px;text-align: center;vertical-align: center;">
        <p-table #patient [value]="patients" [scrollable]="true" dataKey="id" styleClass="p-datatable-sm"
            [loading]="this.loading" [lazy]="true" [rows]="this.query.records_per_page" [totalRecords]="total_records"
            (onLazyLoad)="GetPatients($event)" [paginator]="true" [showCurrentPageReport]="true"
            [(first)]="this.query.first" [scrollable]="true" [autoLayout]="true" [rowsPerPageOptions]="[10,25,50]"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn=" " style="width: 70px;"><b>Sr No</b> </th>

                    <th pSortableColumn="name" style="width: 100px;"><b>Patient Profile</b></th>

                    <th pSortableColumn="name" style="width: 100px;"><b>Reports</b></th>

                    <th pSortableColumn="name" style="width: 150px;"><b>Prescriptions</b></th>

                    <th pSortableColumn="req_no" style="width: 150px;"><b>Req No</b></th>

                    <th pSortableColumn="name"><b>Name</b></th>

                    <th pSortableColumn="age"><b>Age</b></th>

                    <th pSortableColumn="country"><b>Country</b></th>

                    <th pSortableColumn="opinion_type"><b>Opinion Type</b></th>

                    <th pSortableColumn="consultation_date"><b>Consultation Date</b></th>

                </tr>

            </ng-template>
            <ng-template pTemplate="body" let-patient>
                <tr [pSelectableRow]="patient">
                    <td style="width: 70px;">
                        {{patient.sr_no}}
                    </td>
                    <td style="width: 100px;">
                        <button pButton label="View" [disabled]="loading1" (click)="ShowProfile(patient)"></button>
                    </td>
                    <td style="width: 100px;">
                        <button pButton label="View" [disabled]="loading2" (click)="gotoReportpdf(patient)"></button>
                    </td>
                    <td style="width: 150px;">
                        <button pButton label="View" [disabled]="loading3" (click)="gotoprescription(patient)"></button>
                    </td>
                    <td style="width: 150px;">

                        {{patient.req_no}}
                    </td>
                    <td>

                        {{patient.name}}
                    </td>
                    <td>

                        {{patient.age}}
                    </td>
                    <td>

                        <span>{{patient.country}}</span>
                    </td>
                    <td>

                        <span>{{patient.opinion_type}}</span>
                    </td>
                    <td>
                        <span>
                            {{patient.consultation_date == null?'N/A':patient.consultation_date|date:'medium'}}
                        </span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="4">No Patients Found.</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft">
            </ng-template>
            <ng-template pTemplate="paginatorright">
            </ng-template>
        </p-table>

    </div>
</div>
<div *ngIf="patient_guid!=null">
    <p-dialog header="Patient Profile" [(visible)]="openDialog" [baseZIndex]="1000" [closable]="true" [modal]="true"
        (onHide)="Close()">
        <app-patient-profile [patient_guid]='patient_guid' [consultation_id]='consultation_id'>
        </app-patient-profile>

        <ng-template pTemplate="footer">
            <p-button icon="pi pi-check" (click)="Close()" label="Close" styleClass="p-button-text"></p-button>
        </ng-template>
    </p-dialog>
</div>


<p-dialog header="Prescription" *ngIf="displayModel" [(visible)]="displayModel" [modal]="true"
    [contentStyle]="{'overflow':'scroll'}" styleClass="p-dialog-width" [baseZIndex]="10000" [draggable]="false"
    id="prescription" [resizable]="false" (onHide)="CloseDialog()" [style]="{'width':'80%'}">
    <div class="col-md-12">
        <ng-container *ngIf="this.prescriptionData.consultation.p_prescriptions.length > 0">
            <p-button icon="pi pi-check" (click)="print()" label="Print" styleClass="p-button-text"></p-button>

            <app-prescription-details [data]="prescriptionData" [dataId]='showPrescriptiond'></app-prescription-details>


        </ng-container>
        <ng-container *ngIf="this.prescriptionData.consultation.p_prescriptions.length == 0">
            <p>Prescription not available</p>
        </ng-container>
        <h4 *ngIf="this.posting">Fetching data...</h4>
        <p-progressSpinner [style]="{width: '50px', height: '50px'}" *ngIf="this.posting" strokeWidth="6">
        </p-progressSpinner>
    </div>
</p-dialog>
<app-prescription-details *ngIf="displayModel" [data]="this.prescriptionData" [dataId]='printContent'>
</app-prescription-details>




<!-- </ng-container> -->

<ng-container *ngIf="displayModel1">
    <p-dialog header="Report" [(visible)]="displayModel1" [modal]="true" [contentStyle]="{'overflow':'scroll'}"
        [style]="{width: '100vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false"
        (onHide)="CloseDialog()">

        <div *ngIf="this.doctorReportsSuccessd!=null && this.doctorReportsSuccessd==true">

            <div class="spaces"></div>

            <app-doctorreportpdf [data]='this.doctorReportsData' [dataId]='showDoctorReportsd'></app-doctorreportpdf>

            <p-button icon="pi pi-check" (click)="print()" label="Print" styleClass="p-button-text"></p-button>

        </div>

    </p-dialog>

    <div *ngIf="this.doctorReportsSuccessd!=null && this.doctorReportsSuccessd==true">

        <div class="spaces"></div>

        <app-doctorreportpdf [data]='this.doctorReportsData' [dataId]='printContent'></app-doctorreportpdf>

    </div>

</ng-container>


<div class="row container justify-content-center text-center alert alert-danger"
    *ngIf="response.success!=null && response.success==false">
    <p *ngIf="response.error!=null">{{response.error.message}}</p>
    <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
        <p *ngFor="let message of serverError?.message">{{message}}</p>
    </div>
    <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
        <p>{{serverError?.message}}</p>
    </div>

</div>
<h4 *ngIf="posting">Fetching All Patients...</h4>
<p-progressSpinner [style]="{width: '50px', height: '50px'}" *ngIf="posting" strokeWidth="6">